import React from "react";
import { Avatar, Button, Card } from "antd";
import { HeartOutlined, MessageOutlined } from "@ant-design/icons";
import "./chats-dashboard.css";
import { useTheme } from "../../utils/ThemeContext";

const fakeTweets = [
  {
    id: 1,
    user: {
      name: "React",
      handle: "@reactjs",
      avatar:
        "https://w7.pngwing.com/pngs/79/518/png-transparent-js-react-js-logo-react-react-native-logos-icon-thumbnail.png",
      avatar2:
        "https://sweetwaternow.nyc3.cdn.digitaloceanspaces.com/wp-content/uploads/2024/01/Depositphotos_676194222_XL-scaled.jpg",
    },
    date: "Jan 18",
    content:
      "React Conf is back for 2024! Join our co-hosts @Meta and @callstackio May 15-16 in Henderson, Nevada or join the free livestream.\n\nSign up here for updates: conf.react.dev",
    replies: 81,
    likes: 1600,
  },
  {
    id: 2,
    user: {
      name: "React",
      handle: "@reactjs",
      avatar:
        "https://w7.pngwing.com/pngs/79/518/png-transparent-js-react-js-logo-react-react-native-logos-icon-thumbnail.png",
      avatar2:
        "https://sweetwaternow.nyc3.cdn.digitaloceanspaces.com/wp-content/uploads/2024/01/Depositphotos_676194222_XL-scaled.jpg",
    },
    date: "Mar 16, 2023",
    content:
      "Today, we’re thrilled to launch react.dev, the new home for React and its documentation!",
    replies: 45,
    likes: 1200,
  },
  {
    id: 3,
    user: {
      name: "React",
      handle: "@reactjs",
      avatar:
        "https://w7.pngwing.com/pngs/79/518/png-transparent-js-react-js-logo-react-react-native-logos-icon-thumbnail.png",
      avatar2:
        "https://sweetwaternow.nyc3.cdn.digitaloceanspaces.com/wp-content/uploads/2024/01/Depositphotos_676194222_XL-scaled.jpg",
    },
    date: "Mar 16, 2023",
    content:
      "Today, we’re thrilled to launch react.dev, the new home for React and its documentation!",
    replies: 45,
    likes: 1200,
  },
  {
    id: 4,
    user: {
      name: "React",
      handle: "@reactjs",
      avatar:
        "https://w7.pngwing.com/pngs/79/518/png-transparent-js-react-js-logo-react-react-native-logos-icon-thumbnail.png",
      avatar2:
        "https://sweetwaternow.nyc3.cdn.digitaloceanspaces.com/wp-content/uploads/2024/01/Depositphotos_676194222_XL-scaled.jpg",
    },
    date: "Mar 16, 2023",
    content:
      "Today, we’re thrilled to launch react.dev, the new home for React and its documentation!",
    replies: 45,
    likes: 1200,
  },
];

const TwitterFeeds = () => {
  const { theme } = useTheme();
  return (
    <div
      style={{
        borderRadius: "8px",
        backgroundColor: theme === "dark" ? "#232323" : "white",
      }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}
        className="twitter-feeds">
        <h3
          style={{
            marginBottom: "16px",
            color: theme === "light" ? "#232323" : "white",
          }}>
          Twitter Feed
        </h3>
        <button style={{}} className="chat-section-button">
          Account
        </button>
      </div>
      <div
        style={{
          maxWidth: 400,
          margin: "auto",
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}>
        <Card
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            backgroundColor: theme === "dark" ? "#232323" : "white",
          }}
          title=<div
            style={{
              color: theme === "light" ? "#232323" : "white",
            }}>
            "Posts from @reactjs"
          </div>
          extra={
            <Button type="primary" size="small">
              Follow
            </Button>
          }>
          {fakeTweets.map((tweet) => (
            <div
              key={tweet.id}
              style={{
                borderBottom: "1px solid #f0f0f0",
                padding: "16px 0",
              }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                }}>
                <Avatar src={tweet.user.avatar} alt={tweet.user.name} />
                <div style={{ marginLeft: "8px", flex: 1 }}>
                  <strong
                    style={{
                      color: theme === "light" ? "#232323" : "white",
                    }}>
                    {tweet.user.name}
                  </strong>{" "}
                  <span style={{ color: "#8c8c8c" }}>
                    {tweet.user.handle} · {tweet.date}
                  </span>
                </div>
                <Avatar src={tweet.user.avatar2} alt={tweet.user.name} />
              </div>
              <p
                style={{
                  color: theme === "light" ? "#232323" : "white",
                }}>
                {tweet.content}
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  marginTop: "8px",
                  gap: "10px",
                  color: "#8c8c8c",
                }}>
                <span>
                  <MessageOutlined /> {tweet.replies}
                </span>
                <span>
                  <HeartOutlined /> {tweet.likes}K
                </span>
              </div>
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
};

export default TwitterFeeds;
